module.exports = __webpack_public_path__ + "img/io-7.64c3f647.jpg";